import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState
} from './dossier-workflow.action';
import { DossierWorkflow } from './dossier-workflow.model';

export interface DossierWorkflowRecordsState {
    listData: any[];
    singleData: DossierWorkflow;
    loading: boolean;
    updating: boolean;
    stepResendLoadingStatus: boolean;
    error: any;
    total: number;
}

export const initialState: DossierWorkflowRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    stepResendLoadingStatus: false,
    updating: false,
    error: null,
    total: 0,
};


export const DossierWorkflowRecordReducer = createReducer(
    initialState,

    // Fetch Rcords
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    //Reset State
    on(resetState, () => initialState)  // Reset action handler
);